import React from 'react'
import Hero from '../components/contactus/Hero'

function Contactus() {
  return (
    <>
      <Hero/>
    </>
  )
}

export default Contactus